export enum PromotionDebugMode {
  Normal = 'normal',
  Disabled = 'disabled',
  AtmosphereOnly = 'atmosphereOnly',
  ActivityOnly = 'activityOnly',
}

export interface DebugSettings {
  customApiBaseUrl: string;
  useCustomApiBaseUrl: boolean;
  customCookie: string;
  useCustomCookie: boolean;
  hideAppInfo: boolean;
  enableLocalCollect: boolean;
  showPreviewDebugInfo: boolean;
  enablePerformanceDebug: boolean;
  showABTestPanel: boolean;
  enableClientABTest: boolean;
  promotionDebugMode: PromotionDebugMode;
  unlimitedAnonymousProjects: boolean;
  /** 覆盖后端 notify 的前端读值（仅用于调试） */
  notifyOverrides: Partial<Record<string, boolean>>;
}
